import React from 'react';
import { ColumnsType } from 'antd/es/table';
import { SystemOperationLogType } from '../graphql/queries/getSystemOperationLogListing';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export const useOperationLogColumns = (): ColumnsType<SystemOperationLogType> => {
    const { t } = useTranslation();
    return [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: t('central.operationLogs.columns.bizType'),
            dataIndex: 'bizTypeName',
            key: 'bizTypeName',
            width: 120,
        },
        {
            title: t('central.operationLogs.columns.bizId'),
            dataIndex: 'bizId',
            key: 'bizId',
            width: 120,
        },
        {
            title: t('central.operationLogs.columns.operationType'),
            dataIndex: 'operationTypeName',
            key: 'operationTypeName',
            width: 120,
        },
        {
            title: t('central.operationLogs.columns.operator'),
            dataIndex: 'operatorName',
            key: 'operatorName',
            width: 120,
        },
        {
            title: t('central.operationLogs.columns.operatorId'),
            dataIndex: 'operatorId',
            key: 'operatorId',
            width: 120,
        },
        {
            title: t('central.operationLogs.columns.operatedAt'),
            dataIndex: 'operatedAt',
            key: 'operatedAt',
            width: 180,
            render: (timestamp: number) => {
                return dayjs.unix(timestamp).format('YYYY-MM-DD HH:mm:ss');
            },
        },
        {
            title: t('central.operationLogs.columns.description'),
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
        },
        {
            title: t('central.operationLogs.columns.changes'),
            dataIndex: 'changesJson',
            key: 'changesJson',
            width: 300,
            render: (changesJson: string | null | undefined, record: SystemOperationLogType) => {
                // 只显示明文、非加密的变更内容
                if (record.isEncrypted || !changesJson) {
                    return <span style={{ color: '#999' }}>-</span>;
                }
                try {
                    const formattedJson = JSON.stringify(JSON.parse(changesJson), null, 2);
                    return (
                        <pre className="whitespace-pre-wrap break-words max-h-[150px] overflow-y-auto p-2 text-sm bg-gray-50 border rounded">
                            {formattedJson}
                        </pre>
                    );
                } catch (e) {
                    return (
                        <span className="inline-block px-2 py-1 text-sm text-gray-600">
                            {changesJson}
                        </span>
                    );
                }
            },
        },
    ];
};

